import ProductById from "../../components/productById";

function ProductPage() {
  return (
    <div className="productPage">
      <ProductById />
    </div>
  );
}

export default ProductPage;
